import React from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import RestoreIcon from '@mui/icons-material/Restore';
import { useTextColor } from '../theme/ColorContext';

const ColorPicker = () => {
    const { textColor, changeTextColor, resetToDefault, isCustom } = useTextColor();

    return (
        <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 2,
            mb: 2,
            px: 1 
        }}>
            <ColorLensIcon fontSize="small" />
            <input
                type="color"
                value={textColor}
                onChange={(e) => changeTextColor(e.target.value)}
                style={{
                    width: '36px',
                    height: '36px',
                    padding: 0,
                    border: 'none',
                    borderRadius: '50%',
                    background: 'none',
                    cursor: 'pointer'
                }}
            />
            <Typography variant="body2" sx={{ minWidth: 80, fontSize: '0.85rem' }}>
                {isCustom ? "自定义颜色" : "跟随主题默认"}
            </Typography>
            {isCustom && (
                <Tooltip title="恢复为主题默认颜色">
                    <IconButton 
                        onClick={resetToDefault}
                        size="small"
                        color="primary"
                    >
                        <RestoreIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            )}
        </Box>
    );
};

export default ColorPicker; 